module.exports = __webpack_public_path__ + "static/img/3.d8bb408.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/6/1/eng/3.png
// module id = frl2
// module chunks = 0